<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="2" :offset="20">
                    <el-button type="primary" size="mini" @click="add()" class="header-btn">新建</el-button>
                </el-col>
            </el-row>
        </div>
        <el-table :data="appList" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="应用id" prop="id"></el-table-column>
            <el-table-column label="应用名称" prop="name"></el-table-column>
            <el-table-column label="应用key" prop="privateKey"></el-table-column>
            <el-table-column prop="prefix" label="短信后缀"></el-table-column>
            <el-table-column prop="validateCodeLength" label="验证码长度"></el-table-column>
            <el-table-column prop="channelParams" label="三方渠道sdk参数"></el-table-column>
            <el-table-column prop="createDate" label="创建时间">
                <template slot-scope="scope">
                    <span>{{formatDate(scope.row.createDate)}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="updateDate" label="更新时间">
                <template slot-scope="scope">
                    <span>{{formatDate(scope.row.updateDate)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="320">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="success" size="mini" @click="editApp(scope.row)">编辑</el-button>
                        <el-button type="primary" size="mini" @click="handleTemplate(scope.row)">应用消息模板</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="应用配置" :visible.sync="showDialog">
            <el-form :model="appModel" label-width="120px">
                <el-form-item label="应用名称" prop="name">
                    <el-input v-model="appModel.name" placeholder="应用名称"></el-input>
                </el-form-item>
                <el-form-item label="应用后缀">
                    <el-input v-model="appModel.prefix" placeholder="无后缀默认为空"></el-input>
                </el-form-item>
                <el-form-item label="授权参数" prop="channelParams">
                    <el-input v-model="appModel.channelParams" placeholder="第三方调用授权参数 不用填写，用默认值"></el-input>
                </el-form-item>
                <el-form-item label="验证码长度">
                    <el-input-number v-model="appModel.validateCodeLength" :min="0" :max="10" :step="1"
                                     placeholder="没有填写0"></el-input-number>
                </el-form-item>
                <el-form-item>
                    <el-button @click="showDialog = false">取 消</el-button>
                    <el-button type="primary" @click="saveApp()" class="header-btn">
                        保存应用
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getAppListApi, saveAppApi
    } from '../../api/api';
    export default {
        data() {
            return {
                showDialog: false,
                appList: [],
                formInline: {
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                appModel: {
                    id: '',
                    name: '',
                    privateKey: '',
                    prefix: '',
                    validateCodeLength: '',
                    channelParams: '{"accessKeyId":"lechun-mall","accessKeySecret":"123456"}'
                },
                loading: true,
                recordsTotal:0,
                rules: {
                    name: [
                        {required: true, message: '应用名称必填', trigger: 'blur'}
                    ],
                    prefix: [
                        {required: true, message: '应用短信后缀必填', trigger: 'blur'}
                    ],
                    channelParams: [
                        {required: true, message: '第三方调用授权参数', trigger: 'blur'}
                    ]
                }
            }
        },
        created() {

        },
        //挂载时候执行
        mounted(){
            this.getAppList();
        },
        methods: {
            getAppList(){
                //查询模板列表
                getAppListApi(this.formInline).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.recordsTotal = res.data.value.total;
                        this.appList = res.data.value.list;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getAppList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getAppList()
            },
            addApp(){
                this.appModel = {
                    id: '',
                    name: '',
                    privateKey: '',
                    prefix: '',
                    validateCodeLength: '',
                    channelParams: '{"accessKeyId":"lechun-mall","accessKeySecret":"123456"}'
                };
                this.showDialog = true;
            },
            editApp(row){
                this.appModel = {
                    id: row.id,
                    name: row.name,
                    privateKey: row.privateKey,
                    channelParams:row.channelParams,
                    validateCodeLength:row.validateCodeLength,
                    prefix: row.prefix
                };
                this.showDialog = true;
            },
            saveApp(row){
                //保存应用
                saveAppApi(this.appModel).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.getAppList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.showDialog = false;
                });
            },
            handleTemplate(row){
                this.$router.push({
                    path:  '/template',
                    query: {appId:row.id,appName:row.name}
                });
            },
            formatDate(datetime) {
                var date = new Date(datetime);
                var year = date.getFullYear(),
                    month = ("0" + (date.getMonth() + 1)).slice(-2),
                    sdate = ("0" + date.getDate()).slice(-2),
                    hour = ("0" + date.getHours()).slice(-2),
                    minute = ("0" + date.getMinutes()).slice(-2),
                    second = ("0" + date.getSeconds()).slice(-2);
                // 拼接
                var result = year + "-"+ month +"-"+ sdate +" "+ hour +":"+ minute +":" + second;
                // 返回
                return result;
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/sms/baseApp.vue